export default __webpack_public_path__ + "static/media/Blog23.eb8fbda1.jpg";